module.exports = __webpack_public_path__ + "NISSAN-logo.png";